/* FRANK14 · FUORI TUTTO — il mega menu.
   La tenda nera che scende dal bottone del header: tre pannelli (reparti,
   marche, il negozio), i nastri d'oro dietro, la ricerca in cima.

   ATTRIBUTI
     data-menu-apri        il bottone che la apre (nel header)
     data-menu             la tenda
     data-menu-foglio      il foglio nero (il dialogo vero)
     data-menu-chiudi      croce e velo
     data-menu-tab="x"     la linguetta · data-menu-pannello="x" il suo pannello
     data-menu-cursore     il filo d'oro che segue la linguetta scelta
     data-mm-nastro        un nastro (dentro, [data-mm-riga] è la riga che scorre)
     data-menu-pezzo       entra a scalare all'apertura

   Chiusa sta in display:none: le foto dei reparti non pesano sulla home.
   A moto ridotto niente scorrimenti e niente tende: appare e basta. */
(function () {
  var quiete = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pigro = quiete.matches;
  if (quiete.addEventListener) quiete.addEventListener('change', function (e) { pigro = e.matches; });
  var haGsap = typeof window.gsap !== 'undefined';

  var mm = document.querySelector('[data-menu]');
  if (!mm) return;
  var foglio = mm.querySelector('[data-menu-foglio]');
  var lingue = [].slice.call(mm.querySelectorAll('[data-menu-tab]'));
  var pannelli = [].slice.call(mm.querySelectorAll('[data-menu-pannello]'));
  var cursore = mm.querySelector('[data-menu-cursore]');
  var croce = mm.querySelector('.mm__chiudi');

  var aperto = false;
  var inChiusura = false;
  var chiTeneva = null;      /* a chi restituire il fuoco alla chiusura */
  var nastriPronti = false;

  /* ---------- utilità ---------- */
  function pannelloDi(nome) {
    for (var i = 0; i < pannelli.length; i++) {
      if (pannelli[i].getAttribute('data-menu-pannello') === nome) return pannelli[i];
    }
    return null;
  }
  function pannelloVivo() {
    for (var i = 0; i < pannelli.length; i++) if (!pannelli[i].hidden) return pannelli[i];
    return pannelli[0];
  }
  function fuocabili() {
    return [].slice.call(foglio.querySelectorAll(
      'a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])'
    )).filter(function (e) {
      if (e.tabIndex < 0) return false;          /* le linguette non scelte non sono tabbabili */
      return e.offsetWidth > 0 || e.offsetHeight > 0;
    });
  }

  /* ---------- i nastri: si accendono alla prima apertura, quando hanno una larghezza ---------- */
  function accendiNastri() {
    if (nastriPronti || pigro || !haGsap) return;
    nastriPronti = true;
    [].forEach.call(mm.querySelectorAll('[data-mm-nastro]'), function (nastro) {
      var riga = nastro.querySelector('[data-mm-riga]');
      if (!riga) return;
      var larghezza = riga.offsetWidth || 1;
      var copie = Math.max(1, Math.ceil((window.innerWidth * 2) / larghezza));
      for (var k = 0; k < copie; k++) {
        var copia = riga.cloneNode(true);
        copia.setAttribute('aria-hidden', 'true');
        nastro.appendChild(copia);
      }

      var righe = nastro.querySelectorAll('[data-mm-riga]');
      var verso = parseFloat(nastro.getAttribute('data-mm-verso') || '1');
      var velocita = parseFloat(nastro.getAttribute('data-mm-velocita') || '50');
      var durata = Math.max(8, riga.offsetWidth / velocita);

      gsap.set(righe, { xPercent: verso > 0 ? 0 : -100 });
      gsap.to(righe, {
        xPercent: verso > 0 ? -100 : 0,
        duration: durata,
        ease: 'none',
        repeat: -1,
        modifiers: { xPercent: gsap.utils.wrap(-100, 0) }
      });
    });
  }

  /* ---------- aperto o chiuso adesso ----------
     Liquid lo calcola quando genera la pagina: una scheda lasciata aperta
     continuerebbe a dire «Aperto ora» a saracinesca abbassata. Qui si rilegge
     l'orologio di chi guarda, sulle stesse fasce scritte nel markup. */
  function aggiornaStato() {
    var adesso = new Date();
    var giorno = adesso.getDay();
    var minuti = adesso.getHours() * 100 + adesso.getMinutes();
    [].forEach.call(document.querySelectorAll('[data-stato-fasce]'), function (el) {
      var acceso = false;
      if (giorno > 0 && giorno < 7) {
        el.getAttribute('data-stato-fasce').split(',').forEach(function (fascia) {
          var capi = fascia.trim().split('-');
          var da = parseInt(capi[0], 10), a = parseInt(capi[1], 10);
          if (!isNaN(da) && !isNaN(a) && minuti >= da && minuti < a) acceso = true;
        });
      }
      var classe = el.getAttribute('data-stato-classe');
      if (classe) el.classList.toggle(classe, !acceso);
      var voce = el.querySelector('[data-stato-testo]');
      if (voce) {
        voce.textContent = acceso
          ? el.getAttribute('data-stato-aperto')
          : el.getAttribute('data-stato-chiuso');
      }
    });
  }

  /* ---------- il filo d'oro sotto la linguetta ---------- */
  function muoviCursore() {
    if (!cursore) return;
    var viva = null;
    for (var i = 0; i < lingue.length; i++) if (lingue[i].classList.contains('is-scelta')) viva = lingue[i];
    if (!viva) return;
    cursore.style.width = viva.offsetWidth + 'px';
    cursore.style.transform = 'translateX(' + viva.offsetLeft + 'px)';
  }

  /* ---------- l'entrata delle voci di un pannello ---------- */
  function entrata(pannello) {
    if (!pannello || pigro || !haGsap) return;
    var voci = pannello.querySelectorAll('.mm__vetrina, .mm__reparto, .mm__marche li, .mm__pagine li, .mm__lato > *, .mm__eti, .mm__tutto');
    if (!voci.length) return;
    gsap.killTweensOf(voci);
    gsap.fromTo(voci,
      { y: 18, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.55, ease: 'power3.out', stagger: 0.022, overwrite: true, clearProps: 'transform,opacity' }
    );
  }

  /* ---------- scegliere una linguetta ---------- */
  function scegli(nome, animare) {
    lingue.forEach(function (l) {
      var acceso = l.getAttribute('data-menu-tab') === nome;
      l.classList.toggle('is-scelta', acceso);
      l.setAttribute('aria-selected', acceso ? 'true' : 'false');
      l.tabIndex = acceso ? 0 : -1;
    });
    pannelli.forEach(function (p) {
      p.hidden = p.getAttribute('data-menu-pannello') !== nome;
    });
    muoviCursore();
    if (animare) {
      /* senza questo, chi arriva in fondo ai 19 reparti e tocca MARCHE trova
         il pannello nuovo già scorso a metà, con l'elenco che parte dal nulla. */
      foglio.scrollTop = 0;
      var viva = mm.querySelector('.mm__lingua.is-scelta');
      var lingueBox = mm.querySelector('.mm__lingue');
      if (viva && lingueBox && lingueBox.scrollWidth > lingueBox.clientWidth) {
        lingueBox.scrollTo({ left: Math.max(0, viva.offsetLeft - 20), behavior: pigro ? 'auto' : 'smooth' });
      }
      entrata(pannelloDi(nome));
    }
  }

  lingue.forEach(function (l, i) {
    l.tabIndex = i === 0 ? 0 : -1;
    l.addEventListener('click', function () { scegli(l.getAttribute('data-menu-tab'), true); });
    l.addEventListener('keydown', function (e) {
      var passo = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!passo) return;
      e.preventDefault();
      var prossima = lingue[(i + passo + lingue.length) % lingue.length];
      prossima.focus();
      scegli(prossima.getAttribute('data-menu-tab'), true);
    });
  });

  /* ---------- aprire e chiudere ---------- */
  function apri(daChi) {
    if (aperto || inChiusura) return;
    aperto = true;
    chiTeneva = daChi || document.activeElement;

    mm.classList.add('is-attivo');
    mm.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mm-fermo');
    if (window.__lenis) window.__lenis.stop();
    [].forEach.call(document.querySelectorAll('[data-menu-apri]'), function (b) {
      b.setAttribute('aria-expanded', 'true');
    });

    /* si riparte sempre dalla cima: se no la seconda apertura si ricorda
       di dove l'avevi lasciata e l'etichetta finisce sotto la testa. */
    foglio.scrollTop = 0;

    requestAnimationFrame(function () {
      accendiNastri();
      aggiornaStato();
      muoviCursore();
      if (!pigro && haGsap) {
        var tl = gsap.timeline();
        tl.fromTo(foglio,
          { clipPath: 'inset(0% 0% 100% 0%)' },
          { clipPath: 'inset(0% 0% 0% 0%)', duration: 0.72, ease: 'expo.out', clearProps: 'clipPath' });
        tl.fromTo(mm.querySelectorAll('[data-menu-pezzo]'),
          { y: -12, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.5, stagger: 0.07, ease: 'power3.out', clearProps: 'transform,opacity' }, 0.14);
      }
      entrata(pannelloVivo());
      if (croce) croce.focus({ preventScroll: true });
    });
  }

  function chiudi() {
    if (!aperto || inChiusura) return;
    /* la tenda resta a schermo finché il velo non è finito: fino ad allora Esc,
       la trappola del fuoco e il blocco dello scorrimento devono restare accesi,
       se no per quattro decimi di secondo si scorre la pagina sotto la tenda. */
    inChiusura = true;
    mm.style.pointerEvents = 'none';
    [].forEach.call(document.querySelectorAll('[data-menu-apri]'), function (b) {
      b.setAttribute('aria-expanded', 'false');
    });

    function spegni() {
      aperto = false;
      inChiusura = false;
      mm.style.pointerEvents = '';
      mm.classList.remove('is-attivo');
      mm.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mm-fermo');
      if (window.__lenis) window.__lenis.start();
      if (chiTeneva && document.contains(chiTeneva)) chiTeneva.focus({ preventScroll: true });
    }

    if (!pigro && haGsap) {
      gsap.to(foglio, {
        clipPath: 'inset(0% 0% 100% 0%)', duration: 0.42, ease: 'power3.in',
        onComplete: function () { gsap.set(foglio, { clearProps: 'clipPath' }); spegni(); }
      });
    } else {
      spegni();
    }
  }

  [].forEach.call(document.querySelectorAll('[data-menu-apri]'), function (b) {
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function (e) { e.preventDefault(); apri(b); });
  });
  [].forEach.call(mm.querySelectorAll('[data-menu-chiudi]'), function (b) {
    b.addEventListener('click', chiudi);
  });
  /* un link che porta via: si chiude subito, senza affidarsi a un timer che la
     navigazione può battere. E al ritorno dalla cache del browser la pagina
     rinasce com'era: si spegne a mano. */
  [].forEach.call(mm.querySelectorAll('[data-menu-voce]'), function (a) {
    a.addEventListener('click', function () { chiudi(); });
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && aperto) {
      aperto = false; inChiusura = false;
      mm.style.pointerEvents = '';
      mm.classList.remove('is-attivo');
      mm.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mm-fermo');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!aperto) return;
    if (e.key === 'Escape') { e.preventDefault(); chiudi(); return; }
    if (e.key !== 'Tab') return;
    var lista = fuocabili();
    if (!lista.length) return;
    var primo = lista[0], ultimo = lista[lista.length - 1];
    if (!foglio.contains(document.activeElement)) {
      /* il fuoco è scappato fuori dal dialogo (basta un clic su una zona morta,
         che lo scarica su <body>): da lì il Tab uscirebbe nella pagina sotto,
         invisibile sotto la tenda. Lo si riporta dentro. */
      e.preventDefault();
      (e.shiftKey ? ultimo : primo).focus();
      return;
    }
    if (e.shiftKey && document.activeElement === primo) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primo.focus(); }
  });

  window.addEventListener('resize', function () { if (aperto) muoviCursore(); });

  aggiornaStato();
  window.setInterval(aggiornaStato, 60000);

  /* stato di partenza: prima linguetta, pannelli spenti */
  scegli(lingue.length ? lingue[0].getAttribute('data-menu-tab') : 'reparti', false);
})();
